export default "__VITE_ASSET__B3kiI5Ko__"